import NF from "../../assets/images/NF404.png"
import "./NotFound.scss"

const NotFound = () => {
  return (
    <div>
        <img src={NF} alt="NF" className="not-found-jpg"/>
    </div>
  )
}

export default NotFound